import { Line, Rect } from 'react-konva';
import type { FirewallRole } from '@system-atlas/shared';

interface FirewallIconProps {
  role: FirewallRole;
  /** Kantenlaenge der quadratischen Zeichenflaeche in Pixel. */
  size: number;
  color: string;
  x?: number;
  y?: number;
}

/**
 * Rollen-Icon der Firewall aus Konva-Primitiven — spiegelt `firewallIconSvg` in scene-svg.ts
 * (gleiche Bruchteil-Koordinaten): firewall = Ziegelmauer, router = Box mit vier Richtungspfeilen,
 * utm = Schild mit Haken.
 */
export function FirewallIcon({ role, size: s, color, x = 0, y = 0 }: FirewallIconProps) {
  const sw = Math.max(1.5, s * 0.05);
  const st = { stroke: color, strokeWidth: sw, lineCap: 'round' as const, lineJoin: 'round' as const };
  // Bruchteil-Punkte -> absolute Konva-Koordinaten.
  const p = (...pts: number[]) => pts.map((v, i) => (i % 2 === 0 ? x + v * s : y + v * s));

  if (role === 'router') {
    return (
      <>
        <Rect x={x + 0.3 * s} y={y + 0.4 * s} width={0.4 * s} height={0.24 * s} cornerRadius={0.04 * s} {...st} />
        <Line points={p(0.5, 0.4, 0.5, 0.16)} {...st} />
        <Line points={p(0.44, 0.24, 0.5, 0.16)} {...st} />
        <Line points={p(0.56, 0.24, 0.5, 0.16)} {...st} />
        <Line points={p(0.5, 0.64, 0.5, 0.86)} {...st} />
        <Line points={p(0.44, 0.78, 0.5, 0.86)} {...st} />
        <Line points={p(0.56, 0.78, 0.5, 0.86)} {...st} />
        <Line points={p(0.3, 0.52, 0.14, 0.52)} {...st} />
        <Line points={p(0.22, 0.46, 0.14, 0.52)} {...st} />
        <Line points={p(0.22, 0.58, 0.14, 0.52)} {...st} />
        <Line points={p(0.7, 0.52, 0.86, 0.52)} {...st} />
        <Line points={p(0.78, 0.46, 0.86, 0.52)} {...st} />
        <Line points={p(0.78, 0.58, 0.86, 0.52)} {...st} />
      </>
    );
  }
  if (role === 'utm') {
    return (
      <>
        <Line points={p(0.5, 0.16, 0.8, 0.28, 0.8, 0.54, 0.66, 0.74, 0.5, 0.86, 0.34, 0.74, 0.2, 0.54, 0.2, 0.28)} closed {...st} />
        <Line points={p(0.4, 0.52, 0.47, 0.6, 0.62, 0.42)} {...st} />
      </>
    );
  }
  // firewall (Ziegelmauer)
  return (
    <>
      <Rect x={x + 0.16 * s} y={y + 0.22 * s} width={0.68 * s} height={0.6 * s} cornerRadius={0.02 * s} {...st} />
      <Line points={p(0.16, 0.42, 0.84, 0.42)} {...st} />
      <Line points={p(0.16, 0.62, 0.84, 0.62)} {...st} />
      <Line points={p(0.39, 0.22, 0.39, 0.42)} {...st} />
      <Line points={p(0.61, 0.22, 0.61, 0.42)} {...st} />
      <Line points={p(0.28, 0.42, 0.28, 0.62)} {...st} />
      <Line points={p(0.5, 0.42, 0.5, 0.62)} {...st} />
      <Line points={p(0.72, 0.42, 0.72, 0.62)} {...st} />
      <Line points={p(0.39, 0.62, 0.39, 0.82)} {...st} />
      <Line points={p(0.61, 0.62, 0.61, 0.82)} {...st} />
    </>
  );
}
